class UspBanner extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    const content = this.querySelector('.js-usp-banner-content');

    if (!content) return;

    const resizeObserver = new ResizeObserver(() => {
      const contentOverflow = this.offsetWidth <= content.offsetWidth;

      if (contentOverflow) {
        const duration = 15 * (this.offsetWidth + content.offsetWidth);

        content.style.animationDuration = `${duration}ms`;
        this.classList.add('usp-banner--scroll');
      } else {
        content.style.animationDuration = '';
        this.classList.remove('usp-banner--scroll');
      }
    });

    resizeObserver.observe(this);
  }
}

customElements.define('usp-banner', UspBanner);
